import React from "react";
import FieldNumber from "../number/number";

import FieldConfig from "../../proto/field-config";
import {GROUP_NUMBER} from "../../../gd/const/fields/field2-groups";
import FieldPercentage_Editable from "./render/editable/editable";
import {FieldFilterType} from "../../proto/types";

export default class FieldPercentage extends FieldNumber {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Percentage";
        this.typeGroup          = GROUP_NUMBER;
        this.typeDescription    = "Percentage number field";
        this.filterType         = FieldFilterType.NUMBER;
        this.icon               = 'i5-percent';

        // special
        this.decimalPlaces      = _.get(config,'decimalPlaces',0)
        this.positiveOnly       = _.get(config,'positiveOnly',false)
        this.integersOnly       = _.get(config,'integersOnly',false)

        this.components = {
            ValueIcon: <span className={Classes("ui5-ico-14 m-r-10 fl-no-shrink", this.icon)}/>
        }

        this.renderComponents.editable = FieldPercentage_Editable
    }
}
